const config = {
    apiBaseUrl: '', // Base URL for the API http://localhost:8080
    defaultLocale: 'en-IN',//need to override with logged in user locale later
    labelsEndpoint: '/api/v1/field-labels',
  };
  
export default config;